import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import 'rxjs/add/operator/map';

import { Globals } from '../providers/globals';
import { HttpHelper } from '../helpers/httpHelper';
import { Storage } from '@ionic/storage';
import { BaseProvider } from '../providers/base-provider';

@Injectable()
export class ProductPaymentCheckoutHandler extends BaseProvider {
  	businessId: any = 0; 
  	invoiceId: any = 0; 

  	order: any = {
  		consumer: {},
  		products: [],
  		groups: [{
  			products:[],
  			index: 0,
  			total: 0,
  			groupName: ''
  		}],
  		total: 0,
  		businessId: 0,
      paymentTypeId: null
  	};

  	activeGroupIndex: 0;

    paymentTypes: any = []

	constructor(
		public http: Http,
		public globals: Globals,
        public storage: Storage,
        public httpHelper: HttpHelper
	){		
		super()
	}

	clearOrder(){

		this.order = {
  		consumer: {},
  		products: [],
  		groups: [{
  			products:[],
  			index: 0,
  			total: 0,
  			groupName: ''
  		}],
  		total: 0,
  		businessId: 0,
      paymentTypeId: null
  	};

	}
}



// WEBPACK FOOTER //
// ./src/providers/product-payment-checkout-handler.ts